import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // SEO Provider
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import ScrollToTop from './components/ScrollToTop';
import Background from './components/Background'; // 1. Import

// 1. LAZY LOAD PAGES
// Instead of standard imports, we load them on demand
const Home = lazy(() => import('./pages/Home'));
const ProjectDetails = lazy(() => import('./pages/ProjectDetails'));
const AllProjects = lazy(() => import('./pages/AllProjects'));
const ErrorPage = lazy(() => import('./pages/ErrorPage'));

// Loading Fallback Component
const PageLoader = () => (
  <div style={{ 
    height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', 
    background: 'var(--bg-dark)', color: 'var(--accent-gold)' 
  }}>
    <h3>Loading Experience...</h3>
  </div>
);

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          {/* 2. Add Background HERE - Outside the app-container but inside Router/Theme */}
          <Background /> 
          
          <div className="app-container">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/project/:id" element={<ProjectDetails />} />
                <Route path="/all-projects" element={<AllProjects />} />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;